<template>
  <Loader v-if="isLoading"></Loader>
  <b-row v-else>
    <b-col cols="12">
      <router-link v-if="item" :to="{name: 'AppConfiguration'}" class="btn btn-sm btn-default float-right mb-2">{{ $t('buttons.backToList') }}</router-link>
    </b-col>
    <b-col cols="12">
      <b-card>
          <div v-if="confComponent">
            <i class="fa fa-user-lock fa-lg mr-2"></i>
            <span class="h6">{{$t('views.confacl.update.title')}} - {{ confComponent['description'] }}</span>
          </div>
        <div class="card-body">
          <b-row>
            <b-col>
              <ConfAclForm
                      v-if="item"
                      :handle-submit="onSendForm"
                      :handle-update-field="updateField"
                      :values="item"
                      :errors="violations"
                      :initial-values="retrieved" />
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfAclForm from './Form.vue'
import getId from '@/utils/getIdFromLink'
import Loader from '@/components/Dashboard/Layout/Loader'
import ApiService from '@/utils/ApiService'

export default {
  components: {
    ConfAclForm,
    Loader
  },

  data () {
    return {
      item: {},
      confComponent: null
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'confacl/update/isLoading',
      error: 'confacl/update/error',
      deleteError: 'confacl/del/error',
      deleteLoading: 'confacl/del/isLoading',
      created: 'confacl/create/created',
      deleted: 'confacl/del/deleted',
      retrieved: 'confacl/update/retrieved',
      updated: 'confacl/update/updated',
      violations: 'confacl/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'ConfAclList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.getConfComponent(this.getIdLink(this.$route.params.id))
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'confacl/create/reset',
      deleteItem: 'confacl/del/del',
      delReset: 'confacl/del/reset',
      retrieve: 'confacl/update/retrieve',
      updateReset: 'confacl/update/reset',
      update: 'confacl/update/update',
      updateRetrieved: 'confacl/update/updateRetrieved'
    }),

    async getConfComponent (id) {
      const response = await new ApiService(`conf_components/${id}`).getResults()
      this.confComponent = response
    },

    del () {
      if (window.confirm('Are you sure you want to delete this confacl ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
